/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/18.
 */
import normalize from '@/utils/normalize';
import Immutable from 'immutable';
import { Trash, Notes } from '../../constants/actionTypes';

const initialState = {
  list: {
    // entities: undefined, // 文章列表, Immutable中undefined也算是有数据，所以用注释的方法来标识数据结构
    // seq: undefined,
    status: Trash.TRASH_NOTES_LIST_INIT,
  },
  notes: {
  },
};

export default function (state = Immutable.fromJS(initialState), action) {
  switch (action.type) {
    // 获取trash list
    case Trash.GET_TRASH_NOTES_LIST: {
      const { noteId } = action;
      state = state.setIn(['list', 'status'], Trash.GET_TRASH_NOTES_LIST);
      return state;
    }
    case Trash.GET_TRASH_NOTES_LIST_SUCCESS: {
      const { data } = action;
      // 如果没有data则是取得缓存, 无需重新设置data
      if (data) {
        data.sort((a, b) => a.deleted_at - b.deleted_at);
        const { entities, seq } = normalize(data);
        state = state.setIn(['list', 'entities'], Immutable.fromJS(entities));
        state = state.setIn(['list', 'seq'], Immutable.fromJS(seq));
      }
      state = state.setIn(['list', 'status'], Trash.GET_TRASH_NOTES_LIST_SUCCESS);
      return state;
    }
    case Trash.GET_TRASH_NOTES_LIST_FAIL: {
      state = state.setIn(['list', 'status'], Trash.GET_TRASH_NOTES_LIST_FAIL);
      return state;
    }
    // 获取trash content
    case Trash.GET_TRASH_NOTE_CONTENT: {
      const { noteId } = action;
      state = state.setIn(['notes', noteId.toString(), 'status'], Trash.GET_TRASH_NOTE_CONTENT);
      return state;
    }
    case Trash.GET_TRASH_NOTE_CONTENT_SUCCESS: {
      const { noteId, data } = action;
      // 如果没有data则是取得缓存, 无需重新设置data
      if (data) {
        state = state.setIn(['notes', noteId.toString()], Immutable.fromJS(data));
      }
      state = state.setIn(['notes', noteId.toString(), 'status'], Trash.GET_TRASH_NOTE_CONTENT_SUCCESS);
      return state;
    }
    case Trash.GET_TRASH_NOTE_CONTENT_FAIL: {
      const { noteId } = action;
      state = state.setIn(['notes', noteId.toString(), 'status'], Trash.GET_TRASH_NOTE_CONTENT_FAIL);
      return state;
    }
    // 删除trash note
    case Trash.DEL_TRASH_NOTE: {
      const { noteId } = action;
      state = state.setIn(['notes', noteId.toString(), 'status'], Trash.DEL_TRASH_NOTE);
      return state;
    }
    case Trash.DEL_TRASH_NOTE_SUCCESS: {
      const { noteId, data } = action;
      state = state.deleteIn(['notes', noteId.toString()]);
      state = state.deleteIn(['list', 'entities', noteId.toString()]);
      const listSeqIndex = state.getIn(['list', 'seq']).indexOf(+noteId);
      state = state.deleteIn(['list', 'seq', listSeqIndex]);
      return state;
    }
    case Trash.DEL_TRASH_NOTE_FAIL: {
      const { noteId } = action;
      state = state.setIn(['notes', noteId.toString(), 'status'], Trash.DEL_TRASH_NOTE_FAIL);
      return state;
    }
    //  恢复trash note
    case Trash.RECOVERY_TRASH_NOTE: {
      const { noteId } = action;
      state = state.setIn(['notes', noteId.toString(), 'status'], Trash.RECOVERY_TRASH_NOTE);

      return state;
    }
    case Trash.RECOVERY_TRASH_NOTE_SUCCESS: {
      const { noteId, data } = action;
      state = state.deleteIn(['notes', noteId.toString()]);
      const listSeqIndex = state.getIn(['list', 'seq']).indexOf(+noteId);
      state = state.deleteIn(['list', 'seq', listSeqIndex]);
      state = state.deleteIn(['list', 'entities', noteId.toString()]);
      return state;
    }
    case Trash.RECOVERY_TRASH_NOTE_FAIL: {
      const { noteId } = action;
      state = state.setIn(['notes', noteId.toString(), 'status'], Trash.RECOVERY_TRASH_NOTE_FAIL);
      return state;
    }
    // 文章移入回收站
    case Notes.DEL_NOTE_SOFT_SUCCESS: {
      const { data, noteId, nbId } = action;
      const seq = state.getIn(['list', 'seq']);
      // 如果本来就没有数据就不需要手动增加，直接从后端一起啊获取
      if (seq) {
        state = state.setIn(['list', 'entities', noteId], Immutable.fromJS(data));
        state = state.setIn(['list', 'seq'], seq.push(+noteId));
      }
      return state;
    }
    default:
      return state;
  }
}

export const getTrashNotesListState = state => state.TrashNotes.get('list');

export const getTrashNotesState = state => state.TrashNotes.get('notes');




// WEBPACK FOOTER //
// ./src/reducers/Trash/TrashNotesReducer.js